import * as React from 'react';

import {Circle, Path, SvgProps} from 'react-native-svg';

import Icon from './Icon';
import {IconProps} from './type';
import {memo} from 'react';

const SwitchIcon: React.FC<IconProps> = (props: SvgProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      id="primary"
      d="M15,5H9A7,7,0,0,0,9,19h6A7,7,0,0,0,15,5Z"
      fill={props.fill}
    />
    <Circle
      id="secondary"
      cx={14.5}
      cy={12}
      r={3.5}
      fill={'rgb(256, 256, 256)'}
    />
  </Icon>
);

export default memo(SwitchIcon);
